import {
  EDITING_MOVE_IN_COSTS,
  EDITING_RENT_TERMS,
  RESET_NEW_TERM_SETTINGS,
  RESET_ONE_TIME_PAYMENT_REQUEST,
  SAVE_NEW_TERM_SETTINGS,
  SAVE_ONE_TIME_PAYMENT_REQUEST,
} from '@rental-manager/constants/ActionConstants';

export const saveOneTimePaymentRequest = ({ propertyId, oneTimePaymentRequest }) => ({
  type: SAVE_ONE_TIME_PAYMENT_REQUEST,
  propertyId,
  oneTimePaymentRequest,
});

export const resetOneTimePaymentRequest = ({ propertyId }) => ({
  type: RESET_ONE_TIME_PAYMENT_REQUEST,
  propertyId,
});

export const editingRentTerms = (rentTerms) => ({
  type: EDITING_RENT_TERMS,
  rentTerms,
});

export const editingMoveInCosts = (editingMoveInCostsRequest) => ({
  type: EDITING_MOVE_IN_COSTS,
  editingMoveInCostsRequest,
});

export const saveNewTermSettings = (newTermSettings) => ({
  type: SAVE_NEW_TERM_SETTINGS,
  newTermSettings,
});

export const resetNewTermSettings = () => ({
  type: RESET_NEW_TERM_SETTINGS,
});
